import React from "react";

const Login = () => {
  return (
    <div>
      <h1>Logowanie</h1>
      {/* Formularz logowania */}
    </div>
  );
};

export default Login;